import React from 'react';
import ComparisonOverlay from './ComparisonOverlay';
import PropTypes from 'prop-types';
import { parseUrlForProductParams } from '../../../../../services/v2/productsService';
import './DataComparisonTable.css';

/**
 * DataComparisonTable.
 * Table for comparing items in a product package.
 *
 * @author  Manny
 * @param   {Boolean}     props.buyNow          Check if method is buyNow.
 * @param   {Array}       props.data            Product package's data.
 * @param   {String}      props.industryKey     Name of the industry.
 * @param   {Object}      props.industryPackage List of packages for the industry.
 * @param   {String}      props.type            Type of product package data.
 * @returns {JSX.Element} The component markup.
 */

const DataComparisonTable = ({ buyNow, data, industryKey, industryPackage, type }) => {
  let dataContent = null;
  const homeprezzoKeys = [
    'smart_move',
    'homeprezzo_agency',
    'homeprezzo_agency_large',
    'homeprezzo_agent',
    'homeprezzo_small_agency'
  ];
  const isCommercial = industryPackage['cityscope'] != null;
  const dataColumnWidth = industryPackage.lite || industryPackage.cordell_estimator_platinum_lite ? 'table-body col-xs-6 text-center' : 'table-body col-xs-3 text-center'

  let { methodParam } = parseUrlForProductParams(location);
  const renderTitle = (key, title, description) => {
    return <>
      <div className="flex">
        <div className="column semi-bold title-column"id={key}>
          {title}
        </div>
        <div className="column tooltip-column text-right">
          {description && <ComparisonOverlay tooltip={description}/>}
        </div>
      </div>
    </>
  }

  if (data !== undefined) {
    dataContent = Object.keys(data)
      .filter(function (singlePackage) {
        let item = data[singlePackage];
        return (
          (item.conditional === true &&
            industryKey !== undefined &&
            ((industryKey === 'mortgage_brokers_and_financial_planners' &&
              (item.key === 'homeprezzo_agent_lite' || item.key === 'homeprezzo_agent')) ||
              (industryKey === 'real_estate_agencies_and_valuers' &&
                homeprezzoKeys.indexOf(item.key) > -1))) ||
          item.conditional === undefined
        );
      })
      .map(function (singlePackage, index) {
      let item = data[singlePackage];
      return (
        <div className='row table-padding' key={`${item.key || singlePackage}-${index}`}>
          <div className={isCommercial ? 'col-xs-2' : 'col-xs-3'}>
            <span className='semi-bold'>
              {renderTitle(`item_title_${item.key}`, item.title, item.description)}
              {/* {
                  item.sticker === true && item.key === 'homeprezzo_agent_lite' &&
                  <br/>
                } */}
              {item.sticker === true && (
                <span className='new-inline-tag'>
                  <i className='fa fa-star' aria-hidden='true'></i>
                  <span> New</span>
                </span>
              )}
            </span>
          </div>
          {Object.keys(industryPackage)
            .filter(function (singlePackageData) {
              let subItem = industryPackage[singlePackageData];
              return !((buyNow || methodParam?.includes('buyNow')) && subItem.key === 'trial');
            })
            .map(function (singlePackageData, subIndex) {
              let subItem = industryPackage[singlePackageData];
              return (
                <div className={dataColumnWidth} key={`${item.key || singlePackage}-${subItem.key || singlePackageData}-${subIndex}`}>
                  {subItem.features[type] &&
                    subItem.features[type][item.key] !== 'N/A' &&
                    subItem.features[type][item.key] !== 'Metrolpolitan Area' && (
                      <span>{subItem.features[type][item.key]}</span>
                    )}
                  {subItem.features[type] &&
                    subItem.features[type][item.key] === 'Metrolpolitan Area' && (
                      <span>
                        <span>{subItem.features[type][item.key]}</span>
                        <p className='sub-text'>Enquire for national</p>
                      </span>
                    )}
                  {subItem.features[type] && subItem.features[type][item.key] === 'N/A' && (
                    <span>
                      <i className='fa fa-minus tan-text' aria-hidden='true'></i>
                    </span>
                  )}
                </div>
              );
            })}
        </div>
      );
    });
  }

  return <div>{dataContent}</div>;
};

DataComparisonTable.propTypes = {
  buyNow: PropTypes.bool,
  data: PropTypes.array.isRequired,
  industryKey: PropTypes.string,
  industryPackage: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired
};

export default DataComparisonTable;
